/* Define messages here, since default i18n script ignores messages
   from `customizations` folder.
*/

import { defineMessages } from 'react-intl';

export default defineMessages({
  cropImage: {
    id: 'Crop image',
    defaultMessage: 'Crop image',
  },
  undo: {
    id: 'Undo',
    defaultMessage: 'Undo',
  },
  crop: {
    id: 'Crop',
    defaultMessage: 'Crop',
  },
  apply: {
    id: 'Apply',
    defaultMessage: 'Apply',
  },
  flipHorizontally: {
    id: 'Flip horizontally',
    defaultMessage: 'Flip horizontally',
  },
  flipVertically: {
    id: 'Flip vertically',
    defaultMessage: 'Flip vertically',
  },
  brightness: {
    id: 'Brightness',
    defaultMessage: 'Brightness',
  },
  lighten: {
    id: 'Lighten',
    defaultMessage: 'Lighten',
  },
  darken: {
    id: 'Darken',
    defaultMessage: 'Darken',
  },
  warning: {
    id: 'Warning',
    defaultMessage: 'Warning',
  },
  hint_save_after_crop: {
    id: 'hint_save_after_crop',
    defaultMessage:
      'If you save now, the changes cannot be undone. You should therefore make sure to keep a copy of the original image.',
  },
  understood: {
    id: 'Understood',
    defaultMessage: 'Understood',
  },
});
